import { useCallback } from 'react'
import * as React from 'react'
import Styles from './DocumentsTable.module.scss'
import { connectSearchBox } from 'react-instantsearch-dom'
import { Search } from 'blaze-ui/icons/20'

export interface Props {
  onFocus: () => void
  placeholder: string | undefined
  inputRef: React.Ref<HTMLInputElement> | undefined
  disabled?: boolean
  refine: (value: string) => void
  initialValue?: string
  onInputChange: (value: string) => void
  currentRefinement: string
}

export const SearchInput = ({
  refine,
  currentRefinement,
  onFocus,
  placeholder,
  inputRef,
  disabled,
  onInputChange,
}: Props) => {
  const onChange = useCallback(
    (event: any) => {
      const value = event.currentTarget.value

      refine(value)
      onInputChange?.(value)
    },
    [refine, onInputChange],
  )

  return (
    <div className={Styles.inputContainer}>
      <Search size={20} />
      <input
        autoFocus={true}
        className={Styles.input}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        ref={inputRef}
        disabled={disabled}
        autoComplete={'off'}
        value={currentRefinement}
      />
    </div>
  )
}

export const ConnectedSearchInput: React.ComponentClass<any, Props> = connectSearchBox(SearchInput)
